import { useCallback, useState } from 'react';
import ThumbnailModal from './ThumbnailModal';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThumbnailUploader = ({
  onImageLoad,
  minImageHeight,
  minImageWidth,
  tooltipReduced,
  tooltipStandard,
  children,
  onClick,
  disabled,
  description,
  descriptionStandard,
  descriptionReduced,
  use
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const handleOnClick = useCallback(e => {
    setDisplayModal(true);
    if (onClick) onClick(e);
  }, [onClick]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [displayModal && /*#__PURE__*/_jsx(ThumbnailModal, {
      description: description,
      descriptionReduced: descriptionReduced,
      descriptionStandard: descriptionStandard,
      minImageHeight: minImageHeight,
      minImageWidth: minImageWidth,
      onClose: () => setDisplayModal(false),
      onImageLoad: onImageLoad,
      tooltipReduced: tooltipReduced,
      tooltipStandard: tooltipStandard
    }), /*#__PURE__*/_jsx(Button, {
      disabled: disabled,
      onClick: handleOnClick,
      use: use,
      children: children
    })]
  });
};